var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.title,
        width: "460px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.reset,
      },
    },
    [
      _c("div", { staticClass: "reservation-summary" }, [
        _c("span", [_vm._v("总 " + _vm._s(_vm.currentState.totalNum || 0))]),
        _c("span", [
          _vm._v("已核销 " + _vm._s(_vm.currentState.verifiedNum || 0)),
        ]),
        _c("span", [
          _vm._v("已取消 " + _vm._s(_vm.currentState.cancelledNum || 0)),
        ]),
        _c("span", [_vm._v("剩余 " + _vm._s(_vm.remainingNum))]),
      ]),
      _c(
        "div",
        { staticClass: "quantity-row" },
        [
          _c("span", [_vm._v(_vm._s(_vm.quantityLabel))]),
          _c("el-input-number", {
            attrs: {
              min: 1,
              max: _vm.remainingNum || 1,
              disabled: _vm.submitting || !_vm.remainingNum,
            },
            on: { change: _vm.onQuantityChange },
            model: {
              value: _vm.quantity,
              callback: function ($$v) {
                _vm.quantity = $$v
              },
              expression: "quantity",
            },
          }),
        ],
        1
      ),
      _vm.errorMessage
        ? _c("div", { staticClass: "error-message" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { disabled: _vm.submitting }, on: { click: _vm.close } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.submitting,
                disabled: !_vm.remainingNum,
              },
              on: { click: _vm.confirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }